import { ConditionIndexBound, Ranges } from '../../types/condition-index-range.types';

/**
 * This map object will be utilized by the helper function to ascertain true or false values through comparisons based on provided operators.
 */
const operatorsMap: Record<string, (a: number, b: number) => boolean> = {
  ge: (a, b): boolean => a >= b,
  le: (a, b): boolean => a <= b,
  gt: (a, b): boolean => a > b,
  lt: (a, b): boolean => a < b,
  et: (a, b): boolean => a == b
};

/**
 * Determines the associated category for the provided value.
 * @param value - A number value.
 * @param categories - An array of Ranges, which represent the possible categories the value can fall under.
 * @returns A Ranges object of the associated category.
 */
export function getCategoryForValue(value: number, categories: Array<Ranges>): Ranges {
  for (let i: number = 0; i < categories.length; i++) {
    const firstBound: ConditionIndexBound = categories[i].range.lowerBound;
    const secondBound: Partial<ConditionIndexBound> = categories[i].range.upperBound;

    if (firstBound && !secondBound) {
      if (operatorsMap[firstBound.operator](value, firstBound.value)) {
        return categories[i];
      }
    }

    if (categories[i].range?.operator === 'or') {
      if (
        operatorsMap[firstBound.operator](value, firstBound.value) ||
        operatorsMap[secondBound.operator](value, secondBound.value)
      ) {
        return categories[i];
      }
    }

    if (
      operatorsMap[firstBound.operator](value, firstBound.value) &&
      operatorsMap[secondBound.operator](value, secondBound.value)
    ) {
      return categories[i];
    }
  }

  return undefined;
}
